import { useState } from 'react';
import SidePanel from '../../components/SidePanel';

export default function UzavritFlekModal({ smena, isDark, onClose, onSaved }) {
    const [koncovyStav, setKoncovyStav] = useState('');
    const [poznamka, setPoznamka] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [isMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    const handleSubmit = async () => {
        if (!koncovyStav || Number(koncovyStav) < 0) {
            alert('Zadej koncový stav.');
            return;
        }
        setSubmitting(true);
        try {
            const r = await fetch(`/api/finance/pokladna/smeny/${smena.id}/uzavrit`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': token },
                credentials: 'same-origin',
                body: JSON.stringify({
                    koncovy_stav_skutecny_kc: Number(koncovyStav),
                    poznamka: poznamka || null,
                }),
            });
            if (!r.ok) throw new Error(await r.text());
            onSaved?.();
        } catch (e) { alert('Uzavření selhalo: ' + e.message); }
        setSubmitting(false);
    };

    return (
        <SidePanel open={true} onClose={onClose} title="Uzavřít smenu" isDark={isDark} isMobile={isMobile} width={420} modal={true}
            footer={
                <div className="flex gap-2">
                    <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm" style={{ color: 'var(--text-secondary)' }}>Zrušit</button>
                    <button onClick={handleSubmit} disabled={submitting} className="flex-1 py-2 rounded-lg text-sm font-medium text-white" style={{ background: '#ef4444', opacity: submitting ? 0.5 : 1 }}>
                        {submitting ? 'Zavírám…' : 'Uzavřít'}
                    </button>
                </div>
            }
        >
            <div className="p-5 space-y-3 text-sm" style={{ color: 'var(--text-primary)' }}>
                <p className="text-xs" style={{ color: 'var(--text-tertiary)' }}>Manuální uzavření smeny — pro plné vyúčtování rozvozce použij flow „Vyúčtování".</p>
                <div>
                    <label className="text-xs font-medium mb-1 block" style={{ color: 'var(--text-secondary)' }}>Koncový stav fyzicky (Kč)</label>
                    <input type="number" step="0.01" min="0" value={koncovyStav} onChange={e => setKoncovyStav(e.target.value)} placeholder="0.00" autoFocus
                        className="w-full rounded p-2 text-base font-bold"
                        style={{ background: 'var(--surface-base)', color: 'var(--text-primary)', border: '1px solid var(--border-default)' }} />
                </div>
                <div>
                    <label className="text-xs font-medium mb-1 block" style={{ color: 'var(--text-secondary)' }}>Poznámka</label>
                    <textarea value={poznamka} onChange={e => setPoznamka(e.target.value)} placeholder="Volitelně…"
                        className="w-full rounded p-2 text-sm" style={{ background: 'var(--surface-base)', color: 'var(--text-primary)', border: '1px solid var(--border-default)', minHeight: 60 }} />
                </div>
            </div>
        </SidePanel>
    );
}
